export const STATUTS = {
    A: { label: 'EN ATTENTE DE VALIDATION', color: 'cyan', titleColor: 'black' },
    RF: { label: 'REFUSÉ', color: 'red', titleColor: 'black' },
    O: { label: 'OUVERT', color: 'green', titleColor: 'black' },
    I: { label: 'EN INSTANCE', color: 'orange', titleColor: 'black' },
    T: { label: 'TERMINÉ', color: 'green', titleColor: 'black' },
    S: { label: 'SANS SUITE', color: 'blue', titleColor: 'black' },
    R: { label: 'RÉOUVERT', color: 'gray', titleColor: 'black' }
};

export const OPTIONS = {
    permisCategories: [
        { value: 'AM', label: 'AM' },
        { value: 'A1', label: 'A1' },
        { value: 'A2', label: 'A2' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'BE', label: 'BE' },
        { value: 'C1', label: 'C1' },
        { value: 'C', label: 'C' },
        { value: 'D1', label: 'D1' },
        { value: 'D', label: 'D' }
    ],
    conducteurQualites: [
        { value: 'propriétaire', label: 'Propriétaire' },
        { value: 'locataire', label: 'Locataire' },
        { value: 'emprunteur', label: 'Emprunteur' },
        { value: 'salarié', label: 'Salarié' }
    ],
    typeDommages: [
        { value: 'MATERIEL', label: 'Matériel' },
        { value: 'CORPOREL', label: 'Corporel' },
        { value: 'MIXTE', label: 'Mixte' }
    ]
};

export const normalizeStatus = (status) => {
    if (!status) return '';
    return status
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
};

export const getCanonicalStatus = (status) => {
    const normalized = normalizeStatus(status);
    const statusMap = {
        A: ['A', 'AVALIDER', 'ATTENTEVALIDATION', 'ENATTENTEDEVALIDATION'],
        RF: ['RF', 'REFUSE', 'REFUSES', 'REFUSEE', 'REFUSEES'],
        O: ['O', 'OUVERT', 'OUVERTS', 'OUVERTE', 'OUVERTES'],
        I: ['I', 'INSTANCE', 'ENINSTANCE'],
        T: ['T', 'TERMINE', 'TERMINES', 'TERMINEE', 'TERMINEES'],
        S: ['S', 'SANSSUITE', 'SANSUITE'],
        R: ['R', 'REOUVERT', 'REOUVERTS', 'REOUVERTE', 'REOUVERTES']
    };

    for (const [canonical, variants] of Object.entries(statusMap)) {
        if (variants.includes(normalized)) return canonical;
    }
    return normalized;
};

export const conducteurQualiteOptions = [
    { value: "propriétaire", label: "Propriétaire" },
    { value: "locataire", label: "Locataire" },
    { value: "emprunteur", label: "Emprunteur" },
    { value: "salarié", label: "Salarié" },
];

export const resolveNumeroSinistre = (sinistre) => {
    if (!sinistre) return '-';
    const candidates = [
        sinistre.numeroSinistreM,
        sinistre.numeroSinistreP,
        sinistre.numeroSinistre,
        sinistre.numSinistre,
        sinistre.reference,
        sinistre.codeId
    ];
    return candidates.find(c => c && `${c}`.trim()) || '-';
};

export const formatCurrency = (amount) => {
    if (!amount) return '0';
    return new Intl.NumberFormat('fr-FR').format(amount);
};

export const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('fr-FR');
};
